var map = {
	"./ISO9001": 4,
	"./ISO9001.png": 4,
	"./about": 5,
	"./about.jpg": 5,
	"./academy/qr": 6,
	"./academy/qr.png": 6,
	"./address/google": 7,
	"./address/google.svg": 7,
	"./address/waze": 8,
	"./address/waze.svg": 8,
	"./eraf_meemo_en": 9,
	"./eraf_meemo_en.svg": 9,
	"./eraf_meemo_lv": 10,
	"./eraf_meemo_lv.svg": 10,
	"./eraf_sunstar_en": 11,
	"./eraf_sunstar_en.svg": 11,
	"./eraf_sunstar_en_2023": 12,
	"./eraf_sunstar_en_2023.svg": 12,
	"./eraf_sunstar_lv": 13,
	"./eraf_sunstar_lv.svg": 13,
	"./eraf_sunstar_lv_2023": 14,
	"./eraf_sunstar_lv_2023.svg": 14,
	"./fav/academy_favicon": 15,
	"./fav/academy_favicon.ico": 36,
	"./fav/academy_favicon.png": 15,
	"./fav/meemo_favicon": 16,
	"./fav/meemo_favicon.ico": 37,
	"./fav/meemo_favicon.png": 16,
	"./fav/optiv_favicon": 17,
	"./fav/optiv_favicon.ico": 38,
	"./fav/optiv_favicon.png": 17,
	"./fav/sunstar_favicon": 18,
	"./fav/sunstar_favicon.ico": 39,
	"./fav/sunstar_favicon.png": 18,
	"./footer_bg": 19,
	"./footer_bg.png": 19,
	"./logo": 20,
	"./logo.svg": 20,
	"./services": 21,
	"./services.jpg": 21,
	"./social/facebook": 22,
	"./social/facebook.png": 22,
	"./social/instagram": 23,
	"./social/instagram.png": 23,
	"./social/instagram2": 24,
	"./social/instagram2.png": 24,
	"./social/linkedin": 25,
	"./social/linkedin.png": 25,
	"./social/tiktok": 26,
	"./social/tiktok.png": 26,
	"./social/youtube": 27,
	"./social/youtube.png": 27,
	"./social/youtube2": 28,
	"./social/youtube2.png": 28
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35;